import type * as GraphQLTypes from '../../../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetValidGiftCardQueryVariables = GraphQLTypes.Exact<{
  code: GraphQLTypes.Scalars['String'];
}>;


export type GetValidGiftCardQueryResult = (
  { __typename?: 'Query' }
  & { getValidGiftCard?: GraphQLTypes.Maybe<(
    { __typename?: 'GiftCard' }
    & Pick<GraphQLTypes.GiftCard, 'id' | 'code' | 'amount'>
  )> }
);


export const GetValidGiftCardDocument = /*#__PURE__*/ gql`
    query getValidGiftCard($code: String!) {
  getValidGiftCard(code: $code) {
    id
    code
    amount
  }
}
    `;

/**
 * __useGetValidGiftCardQuery__
 *
 * To run a query within a React component, call `useGetValidGiftCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidGiftCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidGiftCardQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetValidGiftCardQuery(baseOptions: Apollo.QueryHookOptions<GetValidGiftCardQueryResult, GetValidGiftCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidGiftCardQueryResult, GetValidGiftCardQueryVariables>(GetValidGiftCardDocument, options);
      }
export function useGetValidGiftCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidGiftCardQueryResult, GetValidGiftCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidGiftCardQueryResult, GetValidGiftCardQueryVariables>(GetValidGiftCardDocument, options);
        }
export type GetValidGiftCardQueryHookResult = ReturnType<typeof useGetValidGiftCardQuery>;
export type GetValidGiftCardLazyQueryHookResult = ReturnType<typeof useGetValidGiftCardLazyQuery>;